import React from 'react'

import { FlexBox } from '../../../components/Base/FlexBox'
import { Button } from '../../../components/Button/Button'
import { SubNav, SubNavItem } from '../../../components/SubNav/SubNav'

interface ProfileSubNavProps {
  items: SubNavItem[]
  subNavOnboardingItems: SubNavItem[]
  isOnboardingTabActive: boolean
}

export function ProfileSubNav({ items, subNavOnboardingItems, isOnboardingTabActive }: ProfileSubNavProps) {
  const tabs = isOnboardingTabActive ? subNavOnboardingItems : items

  return (
    <FlexBox gap="32px" justifyContent="space-between" alignItems="flex-start">
      <SubNav items={tabs} />
      {subNavOnboardingItems.length && !isOnboardingTabActive ? (
        <Button variant="text" size="small" onClick={subNavOnboardingItems[0].onClick}>
          Manage onboarding
        </Button>
      ) : null}
    </FlexBox>
  )
}
